import getEsQuery from '../esParser'
import ElasticsearchAPI from '../../ElasticsearchAPI'

async function income (payload) {
  const jsonQuery = payload.query

  const esSearch = getEsQuery(jsonQuery, payload)
  esSearch.aggs = getIncomeAggregation()

  const response = await ElasticsearchAPI.income(esSearch)
  const results = response
  const aggregations = results.aggregations
  const monthCnt = aggregations.months.buckets.length
  const data = aggregations.incomes.buckets.filter(b => b !== '').map(income => {
    const incomeRng = getIncomeRange(income)
    incomeRng.value = income.ue.value / monthCnt
    return incomeRng
  })
  // return {data}
  return {data: { data }}
}

function getIncomeRange (income) {
  if (income.key === '< $10,000') return {startIncome: 0, finishIncome: 10000}
  if (income.key === '$200,000+') return {startIncome: 200000, finishIncome: 300000}
  const [start, finish] = income.key.replaceAll(/[$,]/g, '').split(' to ').map(i => parseInt(i))
  return {startIncome: start, finishIncome: finish}
}

function getIncomeAggregation () {
  return {
    months: {
      date_histogram: {
        field: 'broadcastdate',
        interval: 'month',
        format: 'yyyy-MM'
      }
    },
    incomes: {
      terms: {
        field: 'household.householdincomerangesdetailed'
      },
      aggs: {
        ue: {
          sum: {
            field: 'intabweight'
          }
        }
      }
    }
  }
}

export default income



// WEBPACK FOOTER //
// ./src/app/api/elasticsearch/LAS/income.js